import styled from 'styled-components';

export default styled.h3`
  font-size: 1.2em;
  font-weight: bold;
  margin: 1.5rem 0 0 0;
`;
